import React, { useEffect } from "react";
import { api } from "../../Services/Axios";
import { useConfig } from "../../context/ConfigContext";
import { track, beaconFlush, setTrackedEmpreendimento } from "../../Services/Analytics";

// Landing hit when a QR code is scanned. The QR encodes /{slug}/qr?e=<empId>
// (see Empreendimento) rather than the raw destination — so the QR stays small
// and the redirect target is resolved server-side (no open-redirect surface).
// We record a slot-8 scan event, ship it, then forward to the empreendimento's
// admin-configured qr-code URL.
//
// Config must be loaded first so analytics is initialised (initAnalytics runs in
// the same config callback / grano_enabled is known); we always redirect
// regardless of whether tracking is on.
const QrRedirect = () => {
  const { appConfig } = useConfig();

  useEffect(() => {
    if (!appConfig.loaded) return undefined; // wait until grano_enabled is known

    const empId = new URLSearchParams(window.location.search).get("e");
    if (!empId) return undefined;

    let cancelled = false;
    api
      .get(`v1/empreendimentos/${empId}`)
      .then((res) => {
        if (cancelled) return;
        const target = (res.data && res.data.data && res.data.data["qr-code"]) || "";
        // Only http(s) — never redirect into javascript:/data: (XSS via location).
        const safe = /^https?:\/\//i.test(target);
        if (safe) {
          setTrackedEmpreendimento(empId);
          track.qr(target); // no-op when grano disabled
          beaconFlush(); // sendBeacon survives the imminent navigation
          setTimeout(() => {
            if (!cancelled) window.location.replace(target);
          }, 200);
        }
      })
      .catch(() => {
        /* unreachable target lookup — leave the "redirecting" splash up */
      });

    return () => {
      cancelled = true;
    };
  }, [appConfig.loaded]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#141414",
        color: "rgba(255,255,255,0.7)",
        fontFamily: "sans-serif",
        fontSize: "1rem",
      }}
    >
      Redirecionando…
    </div>
  );
};

export default QrRedirect;
